import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DraftConverter} from '../converters/draft.converter';
import {environment} from '../../../environments/environment';
import {DraftModel} from '../models/draft.model';
import {Observable} from 'rxjs';
import {map} from "rxjs/operators";
import {DraftsResearchModel} from "../models/drafts-research.model";
import {DraftsResearchConverter} from "../converters/drafts-research.converter";
import {ModifyDraftModel} from "../models/modify-draft.model";
import {ModifyDraftConverter} from "../converters/modify-draft.converter";
import {CreateDraftModel} from "../models/create-draft.model";
import {CreateDraftConverter} from "../converters/create-draft.converter";
import { ConfigurationService } from '../../shared/services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class DraftsService {

  constructor(
    private httpClient: HttpClient,
    private draftConverter: DraftConverter,
    private draftsResearchConverter: DraftsResearchConverter,
    private modifyDraftConverter: ModifyDraftConverter,
    private createDraftConverter: CreateDraftConverter,
    private configurationService: ConfigurationService
  ) {
  }

  getBaseResourceEndpoint(): string {
    return (
      this.configurationService.configuration.api.drafts
    );
  }

  // crea una bozza
  crateDraft(draft: CreateDraftModel): Observable<any> {
    const url = this.getBaseResourceEndpoint();
    return this.httpClient.post(url, this.createDraftConverter.convertToDto(draft));
  }

  // ricerca bozze
  find(draftsResearch: DraftsResearchModel): Observable<Array<DraftModel>> {
    const url = this.getBaseResourceEndpoint() + `/search`;
    let params = this.draftsResearchConverter.convertToDto(draftsResearch);
    return this.httpClient.post(url, params).pipe(
      map((dtos: any) => {
        return this.draftConverter.convertToModelList(dtos);
      }),
    );
  }

  // ricerca per processId
  getByPid(pid: any): Observable<DraftModel> {
    const url = this.getBaseResourceEndpoint() + `/${pid}`;
    return this.httpClient.get(url).pipe(
      map((dtos: any) => {
        return this.draftConverter.convertToModel(dtos);
      }),
    );
  }

  // elimina bozza
  deleteDraft(pid: any): Observable<void> {
    const url = this.getBaseResourceEndpoint() + `/${pid}`;
    return this.httpClient.delete(url).pipe(
      map((dtos: any) => {
        return;
      }),
    );
  }

  editDraft(pid: any, draft: ModifyDraftModel): Observable<DraftModel> {
    const url = this.getBaseResourceEndpoint() + `/${pid}`;
    let params = this.modifyDraftConverter.convertToDto(draft);
    return this.httpClient.patch(url, params).pipe(
      map((dtos: any) => {
        return this.draftConverter.convertToModel(dtos);
      }),
    );
  }
}
